// Editor shared styles as sx prop objects
export const statusLineWrapperSx = {
  mt: 0.5,
  mb: -1,
};
